import React from 'react'
import classnames from 'classnames'
import Configurator from '../../configurator'
import { i18n } from '../../validator'

@i18n()
export default class LandingMainBox extends Configurator {

    render() {
        const { t } = this.props

        return (
            <div
                className={classnames({
                    'Landing-main-box pt-0 pt-md-5 pt-lg-5 pt-xl-0 mb-0 mb-xs-5': true,
                    'pt-0': this.isResponsive(),
                })}
            >
                <div className="Landing-main-box__content">
                    <h1
                        className={classnames({
                            'Landing-main-box__title px-4 px-md-0': true,
                            'font-size-md mb-0': this.isResponsive(),
                        })}
                    >
                        {t('landingMainBoxText')}
                    </h1>
                    <h2
                        className={classnames({
                            'px-4 px-md-0 Landing-main-box__sub-title font-weight-normal text-color-gray-dark-3': true,
                            'pb-5': !this.isResponsive(),
                            'font-size-default line-height-md pb-1 mb-0': this.isResponsive(),
                        })}
                    >
                        {t('landingMainBoxText2')}
                    </h2>
                </div>
            </div>
        )
    }
}
